import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import OrderList from '../components/orders/OrderList';
import OrderForm from '../components/orders/OrderForm';
import OrderDetail from '../components/orders/OrderDetail';
import useAuth from '../hooks/useAuth';
import DeliveryNoteList from '../components/orders/DeliveryNoteList';
import CreateDeliveryNote from '../components/orders/CreateDeliveryNote';
import DeliveryNoteDetails from '../components/orders/DeliveryNoteDetails';

const DNManagement = () => {
    const [view, setView] = useState('list');
    const [selectedDeliveryNoteId, setSelectedDeliveryNoteId] = useState(null);
    const [editMode, setEditMode] = useState(false);

    const handleCreateDeliveryNote = () => {
        setSelectedDeliveryNoteId(null);
        setView('form');
    };

    const handleViewDeliveryNote = (deliveryNoteId, edit = false) => {
        setSelectedDeliveryNoteId(deliveryNoteId);
        setEditMode(edit);
        setView('detail');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedDeliveryNoteId(null);
        setEditMode(false);
    };

    const handleSuccess = () => {
        setView('list');
        setSelectedDeliveryNoteId(null);
        setEditMode(false);
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion des bons de livraison</h1>
            </div>

            {view === 'list' && (
                <DeliveryNoteList
                    onViewDeliveryNote={handleViewDeliveryNote}
                    onCreateDeliveryNote={handleCreateDeliveryNote}
                />
            )}

            {view === 'form' && (
                <CreateDeliveryNote
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'detail' && (
                <DeliveryNoteDetails
                    deliveryNoteId={selectedDeliveryNoteId}
                    editMode={editMode}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}
        </Container>
    );
};

export default DNManagement;